<script lang="ts">
    
    import { createEventDispatcher, onMount } from "svelte";
    import { Alert, Button, Col, FormGroup, Input, Label, Row } from "sveltestrap";
    import type { Rol } from "../../Model/Rol";
    import type { User } from "../../Model/User";
    import { rolesService, usersService } from "../../services";

    const dispatch = createEventDispatcher();

    let roles: Rol[] = [];
    let pass1 = "";
    let pass2 = "";
    let isSaving = false;

    export let user: User;

    onMount(downRoles);

    async function downRoles() {
        roles = await rolesService.findRoles();
    }

    async function onSubmit() {
        if (isSaving) {
            return;
        }
        isSaving = true;
        try {
            if (pass1.length && pass1 == pass2 && pass1.length > 5) {
                user.password = pass1;
            }
            await usersService.saveUser(user);
            dispatch("saved", user);
        } catch (error) {
            console.error(error);
        } finally {
            isSaving = false;
        }
    }

</script>

<form on:submit|preventDefault={onSubmit} novalidate>

    <Row>
        <Col md={8}>
            <FormGroup>
                <Label>Nombre</Label>
                <Input type="text" bind:value={user.name} />
            </FormGroup>
            <FormGroup>
                <Label>Email</Label>
                <Input type="text" bind:value={user.email} />
            </FormGroup>
            <FormGroup>
                <Label>DNI</Label>
                <Input type="text" bind:value={user.dni} />
            </FormGroup>
            <FormGroup>
                <Label>Teléfono</Label>
                <Input type="text" bind:value={user.phone} />
            </FormGroup>
            <FormGroup>
                <Label>Rol</Label>
                <!-- <Input type="text" bind:value={user.rol_name} disabled/>-->
                <select class="form-select" bind:value={user.rol_id} on:change={ () => { console.log(user.rol_id) } }>
                    {#each roles as rol, index}
                        <option value={rol.id}>
                            {rol.name}
                        </option>
                    {/each}
                </select>
            </FormGroup>
            {#if user.rol_id == 3}
                <FormGroup>
                    <Label>Permisos</Label>
                    <Input type="checkbox" label="Permitir iniciar formularios" bind:checked={user.foreman}/>
                </FormGroup>
            {/if}
            <FormGroup>
                <Label>Contraseña</Label>
                <Input
                    type="password"
                    bind:value={pass1} />
            </FormGroup>
            <FormGroup>
                <Label>Repetir contraseña.</Label>
                <Input
                    type="password"
                    bind:value={pass2} />
            </FormGroup>
        </Col>
        <Col md={4}>
            <FormGroup>
                <Label for="exampleEmail">Imagen</Label>
                <Input type="file" bind:value={user.image} />
            </FormGroup>
        </Col>
    </Row>
    <Row>
        <Col>
            {#if pass1.length && pass1 !== pass2}
                <Alert color="warning">¡Atención!: Las contraseñas no coinciden</Alert>
            {/if}
        
            <Button type="submit" color="primary" disabled={isSaving}>
                {isSaving ? 'Guardando...' : 'Guardar'}
            </Button>
        </Col>
    </Row>

</form>
